import type { LoginVerifyResponseType } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc';
import type { GetUserSettingsResponseType } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/SettingsRpc';
import type { PendingProfile } from '../components/AccountAndProfileSection';

function resolveField(
  pendingValue: string | undefined,
  settingsValue: string | undefined,
  loginVerifyValue: string | undefined
): string {
  if (pendingValue !== undefined) return pendingValue;
  if (settingsValue !== undefined) return settingsValue;
  return loginVerifyValue ?? '';
}

export function useProfileFieldValues(
  pendingProfile: PendingProfile,
  userSettings: GetUserSettingsResponseType | undefined,
  loginVerifyData: LoginVerifyResponseType | undefined
) {
  return {
    firstName: resolveField(
      pendingProfile.firstName,
      userSettings?.firstName,
      loginVerifyData?.firstname
    ),
    lastName: resolveField(
      pendingProfile.lastName,
      userSettings?.lastName,
      loginVerifyData?.lastname
    ),
    jobTitle: resolveField(
      pendingProfile.jobTitle,
      userSettings?.jobTitle,
      loginVerifyData?.jobTitle
    ),
    phone: resolveField(
      pendingProfile.phone,
      userSettings?.phone,
      loginVerifyData?.phone
    ),
    company: resolveField(
      pendingProfile.company,
      userSettings?.company,
      loginVerifyData?.company
    ),
  };
}
